import { inject, Service } from '@angular/core';
import { LocalStorageService } from '@core/providers/storage/local-storage.service';
import { CONSTANTS } from '@shared/constants';

/**
 * The page the session last showed, which the app root resumes. It is session state, kept in the
 * session's storage namespace, so Log Out and an expired session forget it with everything else.
 */
@Service()
export class LastUrlStore {
  private localStorage = inject(LocalStorageService);

  remember(url: string): void {
    this.localStorage.store(CONSTANTS.SESSION.LAST_URL, url);
  }

  read(): string | null {
    return this.localStorage.retrieve(CONSTANTS.SESSION.LAST_URL);
  }
}
